/**
 * Calculates National Insurance from salary.
 *
 * @param {number} niQualifyingSalary - The salary that qualifies for NI contributions
 * @param {Object} configYear - The user inputed year
 * @returns {number} - The NI contribution.
 */
export const calculateNationalInsurance = (niQualifyingSalary, config) => {
    // Safety check for config
    if (!config || !config.NI) {
        return 0;
    }
    
    const { LOWER_THRESHOLD, UPPER_THRESHOLD, MIDDLE_RATE, UPPER_RATE } = config.NI;
    if (niQualifyingSalary <= LOWER_THRESHOLD) return 0;
    let ni = 0;
    if (niQualifyingSalary <= UPPER_THRESHOLD) {
      ni = (niQualifyingSalary - LOWER_THRESHOLD) * MIDDLE_RATE;
    } else {
      ni =
        (UPPER_THRESHOLD - LOWER_THRESHOLD) * MIDDLE_RATE +
        (niQualifyingSalary - UPPER_THRESHOLD) * UPPER_RATE;
    }
    return ni;
};